/**
 * @generated SignedSource<<0880550652a800413cb8f67084429f58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettings_mainSettingsFragment$data = {
  readonly alertOnSlow: boolean;
  readonly cutOffOK: boolean | null;
  readonly cutoff: number | null;
  readonly id: string;
  readonly journeyScribeJourneyType: string | null;
  readonly journeyScribeStartingDomain: string | null;
  readonly journeyScribeStartingDomainLocked: boolean;
  readonly journeyScribeStartingURL: string | null;
  readonly name: string;
  readonly " $fragmentType": "selfServiceSettings_mainSettingsFragment";
};
export type selfServiceSettings_mainSettingsFragment$key = {
  readonly " $data"?: selfServiceSettings_mainSettingsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "selfServiceSettings_mainSettingsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cutoff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cutOffOK",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertOnSlow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "journeyScribeStartingDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "journeyScribeStartingDomainLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "journeyScribeStartingURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "journeyScribeJourneyType",
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "84d1dacd1bb03d05e885336876ae3145";

export default node;
